module.exports = __webpack_public_path__ + "img/twint.b96d533a.png";